import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-none d-md-block fixed-bottom-left contact links" }
const _hoisted_3 = { style: {"background":"var(--nevy)"} }
const _hoisted_4 = { class: "text-center" }

import SocialMediaIcons from "@/components/social-media-icons.vue";
import {onMounted, ref} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'footer',
  setup(__props) {


const showFooter = ref(false);
onMounted(() => {
    setTimeout(() => {
        showFooter.value = true;
    }, 500)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (showFooter.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _createVNode(SocialMediaIcons)
              ])
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "d-none d-md-block fixed-bottom-right contact links" }, [
              _createElementVNode("div", null, [
                _createElementVNode("a", { href: "mailto:h.shaker2001@gmail.com " }, " h.shaker2001@gmail.com ")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(SocialMediaIcons, { class: "d-flex flex-row d-md-none align-items-center justify-content-center gap-3 links" }),
                _cache[0] || (_cache[0] = _createElementVNode("div", null, [
                  _createElementVNode("h6", { class: "font-sm" }, " Built by Hossein Shakeri ")
                ], -1))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})